import { z } from "zod";

import { MessageValidate as msg } from "~/lib/messages";
export const schema = z.object({
  start_date: z.date(msg.requiredObj("Tanggal awal")),
  end_date: z.date(msg.requiredObj("Tanggal akhir")),
});
